// extracted by mini-css-extract-plugin
export default {"root":"Accordion_root__SyV-r","spaceBottom":"Accordion_spaceBottom__F+1+B"};